//contenido debe ser en hex
export const downloadDocumentByHex = (nameFile, content) => {
  let pdf = hexDataToBase64(content);
  const linkSource = `data:application/pdf;base64,${pdf}`;
  const downloadLink = document.createElement('a');
  const fileName = nameFile;
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

function hexDataToBase64(hexstring) {
  return btoa(
    hexstring
      .match(/\w{2}/g)
      .map(function(a) {
        return String.fromCharCode(parseInt(a, 16));
      })
      .join('')
  );
}
